import { GET_CITY_BY_STATE, GET_CITY_BY_STATE_SUCCESS, GET_CITY_BY_STATE_FAIL } from 'actions/address';
import * as _ from 'lodash';

const initialState = {
  isLoading: false,
  cityByStates: [],
  page: 1,
  limit: 10,
  totalPages: 1,
  total: 1,
};

const cityByStateReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case GET_CITY_BY_STATE: {
      return { ...state, isLoading: true, cityDetail: {} };
    }

    case GET_CITY_BY_STATE_SUCCESS: {
      if (payload.page === 1) {
        return {
          ...state,
          isLoading: false,
          cityByStates: payload.results,
          page: payload.page,
          limit: payload.limit,
          totalPages: payload.totalPages,
          total: payload.totalResults,
        };
      } else {
        return {
          ...state,
          isLoading: false,
          cityByStates: _.concat(state.cityByStates, payload.results),
          page: payload.page,
          limit: payload.limit,
          totalPages: payload.totalPages,
          total: payload.totalResults,
        };
      }
    }

    case GET_CITY_BY_STATE_FAIL: {
      return { ...state, isLoading: false };
    }

    default:
      return { ...state };
  }
};
export default cityByStateReducer;
